import { fromJS } from 'immutable';

export default {
    setPack: (state, pack) => {
        return state.set('active', pack);
    },
    setPacksConfig: (state, _packs) => {
        const packs = fromJS(_packs);
        const activePack = packs.hasIn(['particulier']) ? 'particulier' : packs.keySeq().first();

        return state.setIn(['list'], packs).set('active', activePack);
    }
};



// WEBPACK FOOTER //
// ./environments/testbench/data/Packs/core.js